export enum NotificationModuleEnum {
	Fund = 1,
	HCM = 2,
	BudgetBuilder = 3,
	FixedAssets = 4,
	EmployeePortal = 5,
}
